import { CSSProperties, JSX, ReactNode } from 'react'

import { cn } from '@bem-react/classname'
import { Dialog } from '@headlessui/react'
import { AnimatePresence, motion } from 'framer-motion'

import './Modal.scss'

const cnModal = cn('Modal')

const backdrop = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
}

const modal = {
  visible: { opacity: 1, scale: 1 },
  hidden: { opacity: 0, scale: 0 },
}

export interface IModal {
  className?: string
  title?: string
  description?: string
  children?: ReactNode
  open: boolean
  onClose: () => void
  styles?: CSSProperties
  type?: 'warning' | 'error' | 'success'
}

export const Modal = ({
  className,
  title,
  description,
  children,
  open,
  onClose,
  styles,
  type = 'success',
}: IModal): JSX.Element => {
  return (
    <AnimatePresence>
      {open && (
        <Dialog
          static
          open={open}
          as={motion.div}
          onClose={onClose}
          className={cnModal()}
        >
          {open && (
            <motion.div
              variants={backdrop}
              initial='hidden'
              animate='visible'
              exit='hidden'
              className={cnModal('backdrop')}
            />
          )}
          {open && (
            <motion.div
              variants={modal}
              initial='hidden'
              animate='visible'
              exit='hidden'
              className={cnModal('fixed')}
            >
              <div className={cnModal('center')}>
                <Dialog.Panel
                  className={cnModal(
                    'panel',
                    {
                      success: type === 'success',
                      warning: type === 'warning',
                      error: type === 'error',
                    },
                    [className],
                  )}
                  style={styles}
                >
                  {title && (
                    <Dialog.Title className={cnModal('title')}>
                      {title}
                    </Dialog.Title>
                  )}
                  {description && (
                    <Dialog.Description className={cnModal('description')}>
                      {description}
                    </Dialog.Description>
                  )}
                  {children}
                </Dialog.Panel>
              </div>
            </motion.div>
          )}
        </Dialog>
      )}
    </AnimatePresence>
  )
}
